import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './modules/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { routes } from './common/constant/routes-constants';
import { getUserView } from './common/constant/common-constants'
import { userViewAction } from "./modules/actions/action";
import { connect } from "react-redux";

import "./common/scss/common.scss";
import MaintenancePage from './MaintenancePage';

function App(props) {

  useEffect(() => {
    let wakeLock = null;

    const requestWakeLock = async () => {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
      } catch (err) {
        console.error('Unable to request wake lock:', err);
      }
    };

    const releaseWakeLock = () => {
      if (wakeLock) {
        wakeLock.release();
      }
    };

    requestWakeLock();

    return () => {
      releaseWakeLock();
    };
  }, []);


  //Screen Width Listener
  useEffect(() => {
    const handleResize = () => {
      // console.log("window.innerWidth::::", window.innerWidth)
      props.userViewAction(getUserView(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // Initial check (important for refresh / orientation change)
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    // <Provider store={store}>
    //   <PersistGate persistor={persistor}>
    <div className='app-container'>
      <div className={`App ${props.config.userView}`} id="App">
        <BrowserRouter>
          <Routes>
            {routes.map((route) => {
              return (
                <Route
                  key={route.key}
                  path={route.path}
                  authNeeded={route.authNeeded}
                  element={route.element}
                />
              )
            })}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
    //   </PersistGate>
    // </Provider>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    config: state.configReducer.config,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userViewAction: (payload) => dispatch(userViewAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


